// src/utils/persist.js
export function loadJSON(key, fallback = null) {
  try { const raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; }
  catch { return fallback; }
}
export function saveJSON(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}
export function removeKey(key) {
  try { localStorage.removeItem(key); } catch {}
}
